import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, take } from 'rxjs';
import { Employee, UserLoginTimestamps } from '@data-terminal/shared-models/employee';
import { BACKEND_URL, ORGANIZATION_REQUEST_PREFIX } from '@data-terminal/data-access/injection-tokens';

@Injectable({
    providedIn: 'root',
})
export class EmployeeApiService {
    private readonly http = inject(HttpClient);
    private readonly backendUrl = inject(BACKEND_URL);
    private readonly orgRequestPrefix = inject(ORGANIZATION_REQUEST_PREFIX);

    private readonly LOGIN_LIST_URL: (userId: string) => string = (userId) =>
        `${this.backendUrl}${this.orgRequestPrefix}getUserMachineLogins/${userId}`;

    private readonly EMPLOYEE_LIST_URL: string = `${this.backendUrl}${this.orgRequestPrefix}persons`;

    public getUserMachineLogins(userId: string): Observable<UserLoginTimestamps[]> {
        return this.http.get<UserLoginTimestamps[]>(this.LOGIN_LIST_URL(userId));
    }

    public getEmployees(): Observable<Employee[]> {
        return this.http.get<Employee[]>(this.EMPLOYEE_LIST_URL).pipe(take(1));
    }
}
